// import React from 'react';
// import { LiaHeadsetSolid } from "react-icons/lia";   
// import { IoShieldCheckmarkOutline } from "react-icons/io5"; 
// import { CiDeliveryTruck } from "react-icons/ci";        
// import { FaMoneyBill1Wave } from "react-icons/fa6";     

// import '../styles/whyus.scss'; 

// const FeatureIcon = ({ IconComponent, title, description }) => (
//     <div className="features__item">
//         <div className="features__icon">
//             <IconComponent />
//         </div>
//         <div className="feature-text">
//             <p className="features__title">{title}</p>
//             <p className="features__description">{description}</p> 
//         </div>
//     </div>
// );

// const WhyUs = () => {
//     return (
//         <section className="hero-section-features">
            
//             {/* --- Left Column: Images (Unchanged Visual Layout) --- */}
//             <div className="hero-section__images">
//                 <div className="image-stack">
//                     <div className="image-stack__large image-1"></div>
//                     <div className="image-stack__center image-2"></div>
//                 </div>
//             </div>

//             <div className="hero-section__content">
//                 <h1 className="content__heading">Why Trust Artiza With Your Vision?</h1>
//                 <p className="content__description">
//                     Our process guarantees clarity, connects you with master artisans, and assures the final quality of your bespoke furniture.
//                 </p>

//                 <div className="features-grid">
//                     <FeatureIcon 
//                         IconComponent={IoShieldCheckmarkOutline} 
//                         title="Vetted Artisan Network" 
//                         description="Access master craftsmen rigorously screened for skill and commitment to excellence."
//                     />
//                     <FeatureIcon 
//                         IconComponent={LiaHeadsetSolid} 
//                         title="Dedicated Project Support" 
//                         description="We handle communication, design updates, and logistics from start to finish."
//                     />
//                     <FeatureIcon 
//                         IconComponent={FaMoneyBill1Wave} 
//                         title="Guaranteed Specification" 
//                         description="Your payment ensures the piece matches your technical drawing and quality expectations."
//                     />
//                     <FeatureIcon 
//                         IconComponent={CiDeliveryTruck} 
//                         title="Seamless Logistics" 
//                         description="We manage material sourcing, shipping, and installation for a worry-free process."
//                     />
//                 </div>

//                 <a href="/login" className="btn-primary">Start Your Custom Project</a>
//             </div>
//         </section>
//     );
// };

// export default WhyUs;



// src/components/WhyUs.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { LiaHeadsetSolid } from 'react-icons/lia';
import { IoShieldCheckmarkOutline } from 'react-icons/io5';
import { CiDeliveryTruck } from 'react-icons/ci';
import { FaMoneyBill1Wave, FaArrowRight, FaStar } from 'react-icons/fa6';
import '../styles/home.scss';

// Placeholder images — swap for real shots when ready
const IMG_LARGE =
  'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?w=800&h=1000&fit=crop';
const IMG_SMALL =
  'https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=600&h=600&fit=crop';

const FEATURES = [
  {
    Icon: IoShieldCheckmarkOutline,
    title: 'Vetted artisan network',
    description:
      'Access master craftsmen rigorously screened for skill, reliability, and commitment to excellence.',
  },
  {
    Icon: LiaHeadsetSolid,
    title: 'Dedicated project support',
    description:
      'We handle communication, design updates, and logistics from start to finish — so you never chase anyone.',
  },
  {
    Icon: FaMoneyBill1Wave,
    title: 'Guaranteed specification',
    description:
      'Your payment secures the piece to match your technical drawing and quality expectations.',
  },
  {
    Icon: CiDeliveryTruck,
    title: 'Seamless logistics',
    description:
      'We manage material sourcing, shipping, and installation for a worry-free process.',
  },
];

const FeatureItem = ({ Icon, title, description }) => (
  <div className="why-feature">
    <span className="why-feature-icon">
      <Icon />
    </span>
    <div className="why-feature-text">
      <h4 className="why-feature-title">{title}</h4>
      <p className="why-feature-description">{description}</p>
    </div>
  </div>
);

const WhyUs = () => {
  return (
    <section className="whyus-section" id="why-us">
      {/* Decorative glows */}
      <span className="whyus-deco whyus-deco-1" />
      <span className="whyus-deco whyus-deco-2" />

      <div className="whyus-inner">
        {/* ============================================
            LEFT — image stack
           ============================================ */}
        <div className="whyus-visual">
          <div className="whyus-image-large">
            <img src={IMG_LARGE} alt="Artisan workshop" />
          </div>

          <div className="whyus-image-small">
            <img src={IMG_SMALL} alt="Finished piece" />
          </div>

          {/* Floating badge over the images */}
          <div className="whyus-badge">
            <span className="whyus-badge-icon">
              <FaStar />
            </span>
            <div>
              <strong>4.8★ rating</strong>
              <span>from 1,200+ artisans</span>
            </div>
          </div>
        </div>

        {/* ============================================
            RIGHT — content
           ============================================ */}
        <div className="whyus-content">
          <span className="whyus-eyebrow">Why Artiza</span>

          <h2 className="whyus-title">
            Why trust Artiza with your <em>vision</em>?
          </h2>

          <p className="whyus-lead">
            Our process guarantees clarity, connects you with master
            artisans, and assures the final quality of your bespoke
            furniture — from the first sketch to the last coat of finish.
          </p>

          {/* ---------- Feature grid ---------- */}
          <div className="whyus-features">
            {FEATURES.map(({ Icon, title, description }) => (
              <FeatureItem
                key={title}
                Icon={Icon}
                title={title}
                description={description}
              />
            ))}
          </div>

          {/* ---------- CTA ---------- */}
          <div className="whyus-actions">
            <Link to="/login" className="whyus-btn whyus-btn-solid">
              Start your custom project
              <FaArrowRight />
            </Link>
           
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;